/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_Open_MapInputs */

const en_image_inspector_open_map = /** @type {(inputs: Image_Inspector_Open_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenStreetMap`)
};

const ar_image_inspector_open_map = /** @type {(inputs: Image_Inspector_Open_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenStreetMap`)
};

const bn_image_inspector_open_map = /** @type {(inputs: Image_Inspector_Open_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenStreetMap`)
};

const de_image_inspector_open_map = /** @type {(inputs: Image_Inspector_Open_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenStreetMap`)
};

const es_image_inspector_open_map = /** @type {(inputs: Image_Inspector_Open_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenStreetMap`)
};

const fr_image_inspector_open_map = /** @type {(inputs: Image_Inspector_Open_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenStreetMap`)
};

const pt_image_inspector_open_map = /** @type {(inputs: Image_Inspector_Open_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenStreetMap`)
};

const zh_image_inspector_open_map = /** @type {(inputs: Image_Inspector_Open_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenStreetMap`)
};

const tr_image_inspector_open_map = /** @type {(inputs: Image_Inspector_Open_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenStreetMap`)
};

const ru_image_inspector_open_map = /** @type {(inputs: Image_Inspector_Open_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenStreetMap`)
};

const pl_image_inspector_open_map = /** @type {(inputs: Image_Inspector_Open_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenStreetMap`)
};

/**
* | output |
* | --- |
* | "OpenStreetMap" |
*
* @param {Image_Inspector_Open_MapInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_open_map = /** @type {((inputs?: Image_Inspector_Open_MapInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_Open_MapInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_open_map(inputs)
	if (locale === "bn") return bn_image_inspector_open_map(inputs)
	if (locale === "de") return de_image_inspector_open_map(inputs)
	if (locale === "es") return es_image_inspector_open_map(inputs)
	if (locale === "fr") return fr_image_inspector_open_map(inputs)
	if (locale === "pt") return pt_image_inspector_open_map(inputs)
	if (locale === "zh") return zh_image_inspector_open_map(inputs)
	if (locale === "tr") return tr_image_inspector_open_map(inputs)
	if (locale === "ru") return ru_image_inspector_open_map(inputs)
	if (locale === "pl") return pl_image_inspector_open_map(inputs)
	return en_image_inspector_open_map(inputs)
});